import { RestaurantBasket } from "./RestaurantBasket";

export default RestaurantBasket;
